import React, { ReactElement } from "react";
import Layout from "../../components/layout";
import MerchantDetails from "../../components/Merchant/Details";

const MerchantDetailsPage = (): ReactElement => {
  return (
    <Layout>
      <MerchantDetails />
    </Layout>
  );
};

export default MerchantDetailsPage;
